import { useEffect, useState } from 'react';
import { Formik } from 'formik';
import * as Yup from 'yup';
import { toast } from 'react-toastify';
import { Input } from '../../../elements/input';
import { useTranslation } from 'react-i18next';
import { useHttpClient } from '../../../shared/http-client';
import { FormFooter } from '../../../elements/form-footer';
import { FieldError } from '../../../elements/field-error/field-error';
import { Select } from '../../../elements/select';


// construccion del objeto yup de validacion del cuestionario
let obligado = {
    name: Yup.string().required('obligatorio'),
    address: Yup.string().required('obligatorio'),
    zipcode: Yup.string().required('obligatorio'),
    city: Yup.string().required('obligatorio'),
    country: Yup.mixed().required('obligatorio')
};
const validacion = Yup.object().shape(obligado);

const initialValues: any = {
    name: '',
    address: '',
    zipcode: '',
    city: '',
    country: ''
};

export const CentrosForm = ({
    item,
    close,
    doDelete
}: {
    item?: any;
    close: () => void;
    doDelete?: (item: any) => void;
}) => {
    const { t } = useTranslation() as { t: (key: string) => string };

    const { api, state } = useHttpClient();
    const [data, setData] = useState<any | null>(null);
    const [countries, setCountries] = useState<any | null>([]);

    useEffect(() => {
        api('/fleet/countries/?limit=9999', 'GET');
    }, []);


    // Load initial data
    useEffect(() => {
        if (item) {
            setData(item);
        }
    }, [item]);

    const beforeSubmit = (values: any | null) => {
        const after = { ...values };

        return after;
    };

    const onSubmit = async (values: any | null) => {
        const enviaremos = beforeSubmit(values);

        if (enviaremos.id) {
            // update

            api(`/fleet/centers/${enviaremos.id}/`, 'PATCH', enviaremos);
        } else {
            // create

            api('/fleet/centers/', 'POST', enviaremos);
        }
    };

    // Handle API responses
    useEffect(() => {
        if (state.data) {
            if (state.path.includes('centers')) {
                if (state.method === 'POST' || state.method === 'PATCH') {
                    toast.success(`${t('common.label.success-saved')}`);
                    close();
                }
            }
            if (state.path.includes('countries')) {
                setCountries(state.data.results);
            }
        }

        if (state.error) {
            if (state.error.name) {
                toast.error(state.error.name[0]);
            }else{
                toast.error('Server Error');
            }
        }
    }, [state]);

    return (
        <Formik
            initialValues={data || initialValues}
            onSubmit={onSubmit}
            validationSchema={validacion}
            enableReinitialize
        >
            {({
                values,
                errors,
                touched,
                setFieldValue,
                handleSubmit,
                isSubmitting
            }) => (
                <form onSubmit={handleSubmit} autoComplete="off">


                    <Input
                        label={t('common.label.name')}
                        type="text"
                        placeholder={t('common.label.name')}
                        name="name"
                        value={values.name}
                        onChange={(value) =>
                            setFieldValue('name', value.name)
                        }
                    />
                    <FieldError
                        touched={touched}
                        errors={errors}
                        field={'name'}
                    />

                    <Select
                        name="country"
                        label={t('common.label.country')}
                        placeholder="Select value"
                        items={countries}
                        value={values.country}
                        onChange={(value) =>
                            setFieldValue('country', value.country)
                        }
                    />
                    <FieldError
                        touched={touched}
                        errors={errors}
                        field={'country'}
                    />

                    <Input
                        label={t('common.form-label.ciudad')}
                        type="city"
                        placeholder={t('common.form-label.ciudad')}
                        name="city"
                        value={values.city}
                        onChange={(value) =>
                            setFieldValue('city', value.city)
                        }
                    />
                    <FieldError
                        touched={touched}
                        errors={errors}
                        field={'city'}
                    />

                    <Input
                        label={t('common.form-label.address')}
                        type="address"
                        placeholder={t('common.form-label.address')}
                        name="address"
                        value={values.address}
                        onChange={(value) =>
                            setFieldValue('address', value.address)
                        }
                    />
                    <FieldError
                        touched={touched}
                        errors={errors}
                        field={'address'}
                    />

                    <Input
                        label={t('common.label.codigo-postal')}
                        type="zipcode"
                        placeholder={t('common.label.codigo-postal')}
                        name="zipcode"
                        value={values.zipcode}
                        onChange={(value) =>
                            setFieldValue('zipcode', value.zipcode)
                        }
                    />
                    <FieldError
                        touched={touched}
                        errors={errors}
                        field={'zipcode'}
                    />

                    <FormFooter
                        item={item}
                        doDelete={doDelete}
                        doSubmit={handleSubmit}
                        close={close}
                    />
                </form>
            )}
        </Formik>
    );
};